import { StoreIcon, User2Icon } from "lucide-react";
import { z } from "zod";

import UserType from "@/components/form/user-type";
import { Button } from "@/components/ui/button";
import { createFileRoute, useNavigate } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/user-type")({
	validateSearch: z.object({
		userType: z.enum(["BUYER", "VENDOR"]).optional()
	}),
	component: RouteComponent
});

function RouteComponent() {
	const navigate = useNavigate();

	const { userType } = Route.useSearch();

	return (
		<section>
			<div className="flex h-screen flex-col items-center justify-center space-y-4">
				<UserType
					isChecked={userType === "BUYER"}
					toggleCheckbox={() =>
						navigate({ to: "/user-type", search: { userType: "BUYER" } })}
					Icon={User2Icon}
					title="Sign up as a Buyer"
					description="Use Intasida to purchase items online to ensure credibility"
				/>
				<UserType
					title="Sign Up as a Vendor"
					Icon={StoreIcon}
					isChecked={userType === "VENDOR"}
					toggleCheckbox={() =>
						navigate({ to: "/user-type", search: { userType: "VENDOR" } })}
					description="Use Intasida to sell your goods to gain your customer's trust"
				/>
				<Button
					disabled={!userType}
					onClick={() => navigate({ to: "/sign-up", search: { userType: userType ?? "BUYER" } })}
					className="mt-10 h-14 w-full max-w-md"
				>
					Continue
				</Button>
			</div>
		</section>
	);
}
